import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('taskHall')

export const FETCH_TASK = createType('FETCH_TASK')



